/* eslint-disable react/no-unescaped-entities */
import React from 'react'

const DataPolicyEN = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: '@import url(https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI);ul.lst-kix_n8twtn9z4nok-0{list-style-type:none}ul.lst-kix_n8twtn9z4nok-1{list-style-type:none}ul.lst-kix_n8twtn9z4nok-2{list-style-type:none}.lst-kix_uu4hq9qxc4wn-0>li:before{content:"-  "}ul.lst-kix_n8twtn9z4nok-7{list-style-type:none}ul.lst-kix_n8twtn9z4nok-8{list-style-type:none}.lst-kix_q4cp6ojyjmum-7>li:before{content:"\\0025cb   "}ul.lst-kix_n8twtn9z4nok-3{list-style-type:none}ul.lst-kix_n8twtn9z4nok-4{list-style-type:none}ul.lst-kix_n8twtn9z4nok-5{list-style-type:none}.lst-kix_q4cp6ojyjmum-8>li:before{content:"\\0025a0   "}ul.lst-kix_n8twtn9z4nok-6{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-3{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-2{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-5{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-4{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-1{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-0{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-7{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-6{list-style-type:none}ul.lst-kix_8z2w83cv6p1u-8{list-style-type:none}ul.lst-kix_q4cp6ojyjmum-3{list-style-type:none}ul.lst-kix_q4cp6ojyjmum-2{list-style-type:none}ul.lst-kix_q4cp6ojyjmum-5{list-style-type:none}ul.lst-kix_q4cp6ojyjmum-4{list-style-type:none}ul.lst-kix_q4cp6ojyjmum-1{list-style-type:none}ul.lst-kix_q4cp6ojyjmum-0{list-style-type:none}.lst-kix_8z2w83cv6p1u-0>li:before{content:"-  "}.lst-kix_8z2w83cv6p1u-1>li:before{content:"-  "}.lst-kix_q4cp6ojyjmum-1>li:before{content:"\\0025cb   "}ul.lst-kix_q4cp6ojyjmum-7{list-style-type:none}ul.lst-kix_q4cp6ojyjmum-6{list-style-type:none}.lst-kix_q4cp6ojyjmum-0>li:before{content:"\\0025cf   "}ul.lst-kix_q4cp6ojyjmum-8{list-style-type:none}.lst-kix_8z2w83cv6p1u-4>li:before{content:"-  "}.lst-kix_n8twtn9z4nok-5>li:before{content:"\\0025a0   "}.lst-kix_8z2w83cv6p1u-3>li:before{content:"-  "}.lst-kix_8z2w83cv6p1u-5>li:before{content:"-  "}.lst-kix_n8twtn9z4nok-4>li:before{content:"\\0025cb   "}.lst-kix_n8twtn9z4nok-6>li:before{content:"\\0025cf   "}.lst-kix_q4cp6ojyjmum-3>li:before{content:"\\0025cf   "}.lst-kix_q4cp6ojyjmum-5>li:before{content:"\\0025a0   "}.lst-kix_uu4hq9qxc4wn-4>li:before{content:"-  "}.lst-kix_8z2w83cv6p1u-2>li:before{content:"-  "}.lst-kix_8z2w83cv6p1u-6>li:before{content:"-  "}.lst-kix_uu4hq9qxc4wn-3>li:before{content:"-  "}.lst-kix_q4cp6ojyjmum-2>li:before{content:"\\0025a0   "}.lst-kix_q4cp6ojyjmum-6>li:before{content:"\\0025cf   "}.lst-kix_uu4hq9qxc4wn-2>li:before{content:"-  "}.lst-kix_n8twtn9z4nok-8>li:before{content:"\\0025a0   "}.lst-kix_n8twtn9z4nok-7>li:before{content:"\\0025cb   "}.lst-kix_uu4hq9qxc4wn-1>li:before{content:"-  "}.lst-kix_q4cp6ojyjmum-4>li:before{content:"\\0025cb   "}ul.lst-kix_uu4hq9qxc4wn-8{list-style-type:none}.lst-kix_8z2w83cv6p1u-8>li:before{content:"-  "}ul.lst-kix_uu4hq9qxc4wn-6{list-style-type:none}.lst-kix_8z2w83cv6p1u-7>li:before{content:"-  "}.lst-kix_n8twtn9z4nok-2>li:before{content:"\\0025a0   "}ul.lst-kix_uu4hq9qxc4wn-7{list-style-type:none}.lst-kix_n8twtn9z4nok-3>li:before{content:"\\0025cf   "}li.li-bullet-0:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_uu4hq9qxc4wn-5>li:before{content:"-  "}ul.lst-kix_uu4hq9qxc4wn-0{list-style-type:none}ul.lst-kix_uu4hq9qxc4wn-1{list-style-type:none}.lst-kix_uu4hq9qxc4wn-6>li:before{content:"-  "}ul.lst-kix_uu4hq9qxc4wn-4{list-style-type:none}ul.lst-kix_uu4hq9qxc4wn-5{list-style-type:none}ul.lst-kix_uu4hq9qxc4wn-2{list-style-type:none}ul.lst-kix_uu4hq9qxc4wn-3{list-style-type:none}.lst-kix_uu4hq9qxc4wn-7>li:before{content:"-  "}.lst-kix_n8twtn9z4nok-1>li:before{content:"\\0025cb   "}.lst-kix_n8twtn9z4nok-0>li:before{content:"\\0025cf   "}.lst-kix_uu4hq9qxc4wn-8>li:before{content:"-  "}ol{margin:0;padding:0}table td,table th{padding:0}.c1{background-color:#ffffff;color:#343535;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Roboto";font-style:normal}.c0{margin-left:36pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c15{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c9{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c4{background-color:#ffffff;color:#343535;font-weight:700;font-size:12pt;font-family:"Roboto";font-style:italic}.c3{background-color:#ffffff;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline;text-decoration-skip-ink:none;font-size:12pt}.c5{padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c19{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c2{background-color:#ffffff;font-size:12pt;font-family:"Roboto";color:#343535;font-weight:400}.c6{background-color:#ffffff;font-size:12pt;font-family:"Roboto";color:#343535;font-weight:700}.c8{color:#000000;font-weight:400;font-size:12pt;font-family:"Roboto";font-style:normal}.c23{color:#000000;font-weight:400;font-size:12pt;font-family:"Albert Sans"}.c17{color:#000000;font-weight:700;font-size:12pt;font-family:"Albert Sans"}.c18{color:#000000;font-weight:400;font-size:11pt;font-family:"Albert Sans"}.c14{background-color:#ffffff;max-width:451.4pt;padding:72pt 72pt 72pt 72pt}.c21{background-color:#ffffff;font-size:12pt;color:#0a0a0a}.c20{color:inherit;text-decoration:inherit}.c7{text-decoration:none;vertical-align:baseline}.c11{padding:0;margin:0}.c13{font-weight:400;font-family:"Roboto"}.c24{font-style:italic}.c22{font-size:26pt}.c16{margin-left:36pt}.c10{height:11pt}.c12{font-style:normal}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c15" id="h.gjdgxs">
                <span className="c7 c12 c23">Privacy Policy</span>
            </p>
            <p className="c15" id="h.k17vweva87wh">
                <span className="c1">As of: October 2023</span>
            </p>
            <p className="c9">
                <span className="c1">
                    To make our parking spaces available for you to book, we need some of your data. Protecting your
                    privacy is very important to us!{' '}
                </span>
            </p>
            <p className="c9">
                <span className="c1">
                    Therefore, we explain here how we handle your data, ensuring it is used only when absolutely
                    necessary and by those who need it.{' '}
                </span>
            </p>
            <p className="c9">
                <span className="c2">
                    Below you will find information on how we process and protect your data, as well as your rights in
                    the context of data protection.
                </span>
            </p>
            <p className="c9">
                <span className="c1">
                    ___________________________________________________________________________________
                </span>
            </p>
            <p className="c5">
                <span className="c7 c12 c17">Who is responsible for processing your personal data</span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">Responsible for processing your data are we, the</span>
            </p>
            <p className="c5 c16">
                <span className="c2">
                    <br />
                    Wemolo GmbH
                    <br />
                    St. Martin Street 72
                    <br />
                    81541 Munich
                    <br />
                    Germany
                    <br />
                    Tel.: +49 (0) 89 356477 60
                    <br />
                </span>
                <span className="c3">
                    <a className="c20" href="mailto:help@wemolo.com">
                        help@wemolo.com
                    </a>
                </span>
                <span className="c21">&nbsp;</span>
                <span className="c2">
                    <br />
                </span>
                <span className="c3">
                    <a className="c20" href="https://www.wemolo.com">
                        www.wemolo.com
                    </a>
                </span>
                <span className="c21">&nbsp;</span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">in cooperation with our data protection officer</span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5 c16">
                <span className="c2">
                    Christian Schmoll
                    <br />
                    Kaiserplatz 2<br />
                    80803 Munich
                    <br />
                    Germany
                    <br />
                </span>
                <span className="c3 c13">
                    <a className="c20" href="mailto:schmoll@lucid-compliance.com">
                        schmoll@lucid-compliance.com
                    </a>
                </span>
            </p>
            <p className="c5 c10 c16">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c6 c7 c12">Why we process your personal data</span>
            </p>
            <p className="c5 c16 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">
                    We collect your data, especially in the context of our booking process, which includes contractual
                    and pre-contractual relationships. Additionally, there might be legal obligations such as invoicing.
                    We request your consent for this, which you can manage and revoke at any time.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">
                    To process your booking, we need the following personal information from you:
                </span>
            </p>
            <ul className="c11 lst-kix_q4cp6ojyjmum-0 start">
                <li className="c0 li-bullet-0">
                    <span className="c1">License plate number,</span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">Email address,</span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">Payment method.</span>
                </li>
            </ul>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">
                    We need your license plate number to authorize you in our systems for parking on a specific parking
                    space according to your booking. For your online payment, we require both your email address and
                    details of the selected payment method.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">
                    If you wish to enjoy the benefits of a user account on our booking platform, we also need your full
                    name, including:
                </span>
            </p>
            <ul className="c11 lst-kix_n8twtn9z4nok-0 start">
                <li className="c0 li-bullet-0">
                    <span className="c1">First name,</span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">Last name. </span>
                </li>
            </ul>
            <p className="c5">
                <span className="c1">This allows us to better support you in all interactions with us.</span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c6 c7 c12">How long we keep your data</span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">
                    We store this data securely until the purpose for which we need your data is fulfilled. Booking data
                    is deleted after the statutory limitation period. In accordance with tax regulations, invoice data
                    is kept for 10 years.{' '}
                </span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c6 c7 c12">Your rights regarding the processing of your personal data by us</span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">
                    First and foremost, you can decide not to provide any of your personal data. Please note that the
                    functions and services of our platform are limited if the use of personal data is required.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c1">
                    If you choose to share personal data with us, you have the following rights under the General Data
                    Protection Regulation (GDPR), which you can exercise at any time:
                </span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c4">Right to Information (Art. 15 GDPR):</span>
                <span className="c1">
                    &nbsp;You can request confirmation from us at any time as to whether we are processing personal data
                    concerning you. If yes, we will provide you with information about:
                </span>
            </p>
            <ul className="c11 lst-kix_uu4hq9qxc4wn-0 start">
                <li className="c0 li-bullet-0">
                    <span className="c1">the purposes for which we process your personal data,</span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">the categories of personal data we process,</span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">
                        the (categories of) recipients to whom we have disclosed or will disclose your personal data,
                    </span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">
                        the specific planned storage duration of your personal data or, if not possible, the criteria
                        used to determine that duration,
                    </span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">
                        any possible automated processing and, if applicable, profiling, its logic, and potential
                        consequences,
                    </span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">
                        the applicable safeguards for data transfers to a third country or international organization
                    </span>
                </li>
            </ul>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c4">Right to Rectification (Art. 16 GDPR)</span>
                <span className="c2 c24">:</span>
                <span className="c6">&nbsp;</span>
                <span className="c1">
                    If the data we have stored about you is incorrect or incomplete, we must correct it according to
                    your specifications.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c4">Right to Erasure (Art. 17 GDPR)</span>
                <span className="c1">
                    : Is it better for us to part ways? You can demand the immediate deletion of your personal data if
                    one of the following reasons applies:
                </span>
            </p>
            <ul className="c11 lst-kix_8z2w83cv6p1u-0 start">
                <li className="c0 li-bullet-0">
                    <span className="c1">
                        The purpose for which we collected your personal data has ceased to exist.
                    </span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">
                        You have revoked your consent for data processing or there is no legal basis for it anymore.
                    </span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">You object to the processing of your personal data.</span>
                </li>
                <li className="c0 li-bullet-0">
                    <span className="c1">
                        We or a third party made a mistake, and your personal data was unlawfully processed.
                    </span>
                </li>
            </ul>
            <p className="c5 c10">
                <span className="c1" />
            </p>
            <p className="c5">
                <span className="c4">Right to Restriction of Processing (Art. 18 GDPR): </span>
                <span className="c1">
                    If you dispute the accuracy of your data or need the data for legal claims, you can request us to
                    restrict the processing of your personal data.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c4 c7" />
            </p>
            <p className="c5">
                <span className="c4">Right to Data Portability (Art. 20 GDPR): </span>
                <span className="c1">
                    You have the right to request your personal data from us in a "structured, commonly used, and
                    machine-readable format." This applies to all personal data that we process based on your consent
                    and automatically. Upon receipt, you can transfer the data to another party or request direct
                    transmission from our systems to another provider's systems.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c4 c7" />
            </p>
            <p className="c5">
                <span className="c4">Right to Object (Art. 22 GDPR): </span>
                <span className="c1">
                    You can revoke your consent to the processing of your personal data at any time.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c4 c7" />
            </p>
            <p className="c5">
                <span className="c4">Right to Lodge a Complaint with a Supervisory Authority (Art. 77 GDPR):</span>
                <span className="c1">
                    &nbsp;Did we do something wrong? You can always contact the relevant supervisory authority! The
                    authority is usually located at your usual place of residence, workplace, or our company
                    headquarters.
                </span>
            </p>
            <p className="c5 c10">
                <span className="c4 c7" />
            </p>
            <p className="c10 c19">
                <span className="c7 c12 c18" />
            </p>
        </>
    )
}

export default DataPolicyEN
